import React from 'react';
import translate from '../_utils/tools/translate';

export default function EmptyCart({ children }) {
  return (
    <div className="row">
      <div className="col-md-8 col-lg-9">
        <section>
          <h4>
            <strong>Your photo {translate('cart')}:</strong> 0 items
          </h4>
          <p>
            <strong>There are no items in your {translate('cart')}</strong>
          </p>
        </section>
        <hr />
      </div>
      <aside className="col-md-4 col-lg-3">{children}</aside>
    </div>
  );
}
